// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3kosS","file":"styles_file__Rs3tW"};